import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'

const CreateFrameworkTestModal = ({
    showCreateFrameworkTestModal,
    setShowCreateFrameworkTestModal,
    createFrameworkTest,
    createFlexibleTest,
}) => {
    const [framework, setFramework] = useState(null)
    const [errorMessage, setErrorMessage] = useState('')

    const flexibleTestFields = {
        name: true,
        framework: true,
        inputs: true,
        testSuite: true,
        cpuTimeLimit: true,
        memoryLimit: true,
    }

    const frameworkTestFields = {
        name: true,
        framework: true,
        testSuite: true,
        mainClassName: true,
        cpuTimeLimit: true,
        memoryLimit: true,
        fixtureFiles: true,
    }

    const isFlexibleFramework = framework === 'flexible'

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return (isFlexibleFramework ? createFlexibleTest : createFrameworkTest)(
            token, 
            fields, 
            setErrorMessage
        )
    }

    return (
        <TestModal
            showModal={showCreateFrameworkTestModal}
            setShowModal={setShowCreateFrameworkTestModal}
            submitTest={handleSubmitTest}
            modalTitle='Create Framework Test'
            submitButtonText='Create'
            fields={isFlexibleFramework ? flexibleTestFields : frameworkTestFields}
            setFramework={setFramework}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showCreateFrameworkTestModal: unitTests.showCreateFrameworkTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowCreateFrameworkTestModal: value => {
            dispatch(unitTestsActions.setShowCreateFrameworkTestModal(value))
        },
        createFrameworkTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.createFrameworkTest(token, fields, setResponseMessage))
        },
        createFlexibleTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.createFlexibleTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateFrameworkTestModal)
